import { createContext } from "react";

const DiscussionQuestionContext = createContext({
  user: null
});

export default DiscussionQuestionContext;
